import { alpha } from '@mui/material';
/**
 * Blue colors by shade number
 */
export var blue02 = '#e8f3ff';
export var blue05 = '#c1dffd';
export var blue10 = '#9ecdfc';
export var blue20 = '#64aef8';
export var blue30 = '#3c96f1';
export var blue40 = '#2284e6';
export var blue50 = '#106ecc';
export var blue60 = '#085db3';
export var blue70 = '#02488d';
export var blue80 = '#002c57';
export var blue90 = '#000d19';
/**
 * Opaque alternatives
 */
export var blue20opacity10 = alpha(blue20, 0.1);
export var blue20opacity15 = alpha(blue20, 0.15);
export var blue20opacity20 = alpha(blue20, 0.2);
export var blue20opacity50 = alpha(blue20, 0.5);
export var blue50opacity50 = alpha(blue50, 0.5);
